import React, { forwardRef, type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'
import { CardFrame } from '@/components/base/CardFrame'
import { BackgroundImage } from '@/components/base/BackgroundImage'
import { GiftIcon } from '@/icons'
import { Dialog } from '@/components/composite/Dialog'
import { RetentionDialogHeader } from '@/components/composite/RetentionDialogHeader'
import { CheckInItem } from '@/components/layout/CheckInItem'

export interface DailyCheckInDialogProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean
  title: string
  subtitle: string
  bgImageUrl: string
  onClose: () => void
  footerNote?: React.ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const DailyCheckInDialog = forwardRef<HTMLDivElement, DailyCheckInDialogProps>(
  (
    {
      open,
      title,
      subtitle,
      bgImageUrl,
      onClose,
      footerNote,
      accentColor = 'none',
      className,
      ...props
    },
    ref
  ) => {
    return (
      <Dialog
        accentColor={accentColor}
        className={twMerge('w-[230px]', 'flex flex-col items-center', 'pb-2 pt-5', className)}
        onClose={onClose}
        open={open}
        ref={ref}
        {...props}
      >
        {bgImageUrl ? (
          <BackgroundImage className="opacity-10 h-[200px]" imageSrc={bgImageUrl} />
        ) : null}

        <RetentionDialogHeader
          accentColor="yellow"
          icon={<GiftIcon />}
          subtitle={subtitle}
          title={title}
        />

        <CardFrame className="my-2 z-10">
          <CheckInItem
            boostLabel="Multiplier Boost"
            boostPercent={2}
            status="unused"
            title="Day 3"
          />
        </CardFrame>

        {footerNote ? (
          <div className="text-center text-white/60 text-sm z-10">{footerNote}</div>
        ) : null}
      </Dialog>
    )
  }
)

DailyCheckInDialog.displayName = 'DailyCheckInDialog'
